export type CanvasFuseLabel = { rating: number; review?: string };

export function formatCanvasFuse(fuse: CanvasFuseLabel): string {
  return `${fuse.rating}A${fuse.review ? ` · ${fuse.review}` : ""}`;
}
